import { html } from 'lit-html';
import { RrAreaModal } from '../../rr_item/rr_area_modal';
import { MyCatalogModal } from '../../../../models/my_catalog_register/my_catalog_modal';

export const RrBodyMyCatalogModal = (model: MyCatalogModal) => html`
  ${RrAreaModal(model.rrAreaProfileMyCatalogModal!, model.isLogin)}
`;
